import moment from 'moment-timezone';

/**
 * Converts a date string to a `moment.Moment` object.
 *
 * @param string - The date string to convert.
 * @returns The converted date as a `moment.Moment` object.
 */
export const stringToDate = (string: moment.MomentInput): moment.Moment => {
  return moment(string);
};

/**
 * Calculates the absolute number of days between two given dates.
 *
 * @param firstDate - The first date as a `moment.Moment` object.
 * @param secondDate - The second date as a `moment.Moment` object.
 * @returns The absolute difference in days between the two dates as a number.
 */
export const daysBetweenDates = (firstDate: moment.Moment, secondDate: moment.Moment) => {
  return Math.abs(firstDate.diff(secondDate, 'days'));
};

/**
 * Calculates the absolute number of minutes between a given date and the current date.
 *
 * @param date - The date to compare against the current date.
 * @returns The absolute difference in days between the given date and the current date as a number.
 */
export const minutesLeftTo = (date: moment.Moment) => {
  const current = moment();
  return moment(date).diff(current, 'minutes');
};
